import { AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Text } from "@/components/ui/Text";

import type { IncompleteTwinDelivery } from "@/features/studies/incompleteTwinDelivery";

interface IncompleteTwinDeliveryNoticeProps {
  delivery: IncompleteTwinDelivery;
}

export function IncompleteTwinDeliveryNotice(
  props: IncompleteTwinDeliveryNoticeProps,
) {
  const { delivery } = props;

  const { t } = useTranslation("app");

  return (
    <div
      data-testid="incomplete-twin-delivery"
      role="status"
      className="mt-3 flex items-start gap-2.5 rounded-xl border border-amber-300/60 bg-amber-50 px-4 py-3 dark:border-amber-400/30 dark:bg-amber-400/10"
    >
      <AlertCircle className="mt-0.5 h-4 w-4 shrink-0 text-amber-700 dark:text-amber-300" />
      <div className="space-y-1">
        <Text size="sm" className="font-medium text-amber-900 dark:text-amber-200">
          {t("studyReport.incompleteTwins", {
            completed: delivery.completed,
            requested: delivery.requested,
          })}
        </Text>
        <Text size="xs" className="text-amber-900/80 dark:text-amber-200/80">
          {t("studyReport.incompleteTwinsHelp", { count: delivery.failed })}
        </Text>
      </div>
    </div>
  );
}
